import { render } from "./Form.vue?vue&type=template&id=6e355d1e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=6e355d1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e355d1e"

export default script